import { render, staticRenderFns } from "./UserSearchesTab.vue?vue&type=template&id=84c99512"
import script from "./UserSearchesTab.vue?vue&type=script&lang=js"
export * from "./UserSearchesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports